import React from 'react';

const Recipe=(props)=>{

    return(
        <div className="card">
            <h2>{props.label}</h2>
            <img src={props.img} alt=""/>
            <h4>Ingredients</h4>
            <div className="ingredients">
                {props.ingre.map(a=>(<p>--  {a}</p>))}
            </div>
            <div className="link">
                <h3><a target="_blank"href={props.url}>Get full Recipe</a></h3>
            </div>
            
            
        </div>
    );


};
export default Recipe;